<template>
  <div>
    <vs-card>
      <div :key="index" v-for="(chunk, index) in chunks(plants, 2)" class="parent">
        <div class="label-row" :class="{ 'new-page': index % 10 === 0 && index !== 0 }">
          <div :key="i" v-for="(plant, i) in chunk" class="label-container border border-radius left" :class="{ mLeft: i === 1 }">
            <div class="detail-container">
              <p>
                <b>Strain Name : </b>
                {{ plant.plant_name }}
              </p>
              <p>
                <b>Serial Number :</b>
                {{ plant.serialNumber }}
              </p>
              <p>
                <b>Batch Number :</b>
                {{ plant.batch && plant.batch.batch_number }}
              </p>
              <p>
                <b>Start Date :</b>
                {{ date }}
              </p>
            </div>
            <div class="barcode-container">
              <bar-code style="width: 75px" :options="options" :value="plant.serialNumber" />
              <bar-code style="width: 75px" :options="options" :value="plant.batch && plant.batch.batch_number" />
            </div>
          </div>
        </div>
        <!-- <hr class="hrline" /> -->
      </div>
    </vs-card>
    <div v-html="html" />
  </div>
</template>

<script>
import BarCode from '@/components/utils/BarCode.vue'

export default {
  name: 'NonThermalPlants',
  props: ['plants', 'date'],
  data: () => ({
    options: {
      format: 'CODE128B',
      width: 1,
      height: 20,
      fontSize: 10,
      margin: 2
    },
    html: `<style>
      body {
        font-size: 7px;
      }

      @page {
        width:8.5in;
        height: 11in;
        /* padding-top: 0px;
        padding-bottom: 0px; */
        padding-left: 10px;
        padding-right: 10px;
      }

      .container {
        width: 8.2in;
        height: auto;
        /* padding-top: 15px;
        padding-bottom: 15px; */
        // padding-left: 10px;
        // padding-right: 10px;
      }

      @media screen {
        .border {
          border: 1px solid;
        } 
        
        .border-radius {
          border-radius: 5px;
        }
      }

      .label-container.left {
        margin-left: 20px;
      }

      .label-container.mLeft {
        margin-left: 50px;
      }

      .label-container {
        width:10in;
        height: 1in;
        margin: 0;
        padding: 4px;
        display: inline-flex;
        // margin-top: 12px;
        align-items:center;
      }

      .detail-container {
        width: 1.3in;
        // margin-left: 8px;
        // margin-right: 10px;
        font-size: 7px;
      }
      .detail-container p{
        margin:4px;
      }

      .label-row {
        width: 8.5in;
        display: inline-flex;
      }

      .hrline {
        color: #f2f2f2;
        border: 0.5px solid;
        margin: 5px;
      }

      .barcode-container {
        width: 2in;
        margin-top: 22px;
      }

      .new-page {
        page-break-before: always;
        margin-top: 10px;
      }
    </style>`
  }),
  methods: {
    chunks(array, size) {
      return Array.apply(0, { length: Math.ceil(array.length / size) }).map((_, index) => array.slice(index * size, (index + 1) * size))
    }
  },
  components: {
    BarCode
  }
}
</script>
